/**
 * viewStyleListItem
 */

// Module dependencies
import 'protons';

// Module styles
import './_view-style-list-item.scss';

// Module template
import './_view-style-list-item.twig';

export const name = 'viewStyleListItem';

export const defaults = {
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { viewStyleListItem = {} }) {
}

export default enable;
